import Layout from "../../../layout/Layout";
import {
  Grid,
  FormLabel,
  TextField,
  FormControl,
  Typography,
  Button,
  Autocomplete,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { config, payslipDetailsAPI } from "../../../config";
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { AlertMessage } from "../../../components/AlertMessage";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate, useParams } from "react-router-dom";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { manageCompaniesAPI } from "../../../config";
import NavigationGuard from "../../../layout/NavigationGuard";
import { tr } from "date-fns/locale";

const defaultValues = {
  intBasicPayPercentage: "",
  intHouseRentAllowance: "",
  intVehicleAllowance: "",
  intOtherAllowance: "",
  intMedicalAllowance: "",
  txtCompanyName: "",
  intEsiPercentage: "",
  intEpfPercentage: "",
};

function ManageAllowancesAdd() {
  const { id } = useParams();
  const isEditMode = Boolean(id);
  const navigate = useNavigate();

  // validation schema
  const validationSchema = Yup.object().shape({
    intBasicPayPercentage: Yup.number()
      .typeError("Please enter a valid number")
      .max(100, "Should not exceed 100")
      .nullable()
      .transform((value, originalValue) => originalValue === "" ? null : value),
    intHouseRentAllowance: Yup.number()
      .typeError("Please enter a valid number")
      .max(100, "Should not exceed 100")
      .nullable()
      .transform((value, originalValue) => originalValue === "" ? null : value),
    intVehicleAllowance: Yup.number()
      .typeError("Please enter a valid number")
      .nullable()
      .transform((value, originalValue) => originalValue === "" ? null : value),
    intOtherAllowance: Yup.number()
      .typeError("Please enter a valid number")
      .nullable()
      .transform((value, originalValue) => originalValue === "" ? null : value),
    intMedicalAllowance: Yup.number()
      .typeError("Please enter a valid number")
      .max(100, "Should not exceed 100")
      .nullable()
      .transform((value, originalValue) => originalValue === "" ? null : value),
    txtCompanyName: Yup.string().required("Company Name is required"),
    intEsiPercentage: Yup.number()
      .typeError("Please enter a valid number")
      .max(100, "Should not exceed 100")
      .nullable()
      .transform((value, originalValue) => originalValue === "" ? null : value),
    intEpfPercentage: Yup.number()
      .typeError("Please enter a valid number")
      .max(100, "Should not exceed 100")
      .nullable()
      .transform((value, originalValue) => originalValue === "" ? null : value),
  });

  const formOptions = { resolver: yupResolver(validationSchema) };

  // getting all companies name
  const [companyName, setCompanyName] = React.useState("");
  const [companyNames, setCompanyNames] = React.useState([]);

  const childRef = useRef();
  const tempRefs = useRef(false);

  const { register, handleSubmit, reset, formState, setValue } =
    useForm(formOptions);
  const { errors } = formState;

  useEffect(() => {
    if (tempRefs.current === false) {
      const data = {
        intType: 5,
        // intParentId: 42,
      };

      // config.method = 'POST';
      // config.data = JSON.stringify(data);
      // config.url = manageCompaniesAPI;

      const config = {
        method: "POST",
        data: JSON.stringify(data),
        url: manageCompaniesAPI,
        headers: {
          "Content-Type": "application/json",
        },
      };

      axios(config)
        .then(function (response) {
          setCompanyNames(response.data.result);
        })
        .catch(function (error) {
          console.log(error);
        });
      return () => {
        tempRefs.current = true;
      };
    }
  }, []);

  function onSubmit(data) {
    const data1 = JSON.stringify({
      intBasicPayPercentage: data.intBasicPayPercentage,
      intHouseRentAllowance: data.intHouseRentAllowance,
      intVehicleAllowance: data.intVehicleAllowance,
      intOtherAllowance: data.intOtherAllowance,
      intType: 1,
      intMedicalAllowance: data.intMedicalAllowance,
      txtCompanyName: parseInt(data.txtCompanyName),
      intEsiPercentage: data.intEsiPercentage,
      intEpfPercentage: data.intEpfPercentage,
      intPayslipID: parseInt(id || 0),
    });

    config.method = "POST";
    config.data = data1;
    config.url = payslipDetailsAPI;

    axios(config)
      .then(function (response) {
        childRef.current.triggerAlert(
          JSON.stringify({
            message: "Allowances data updated",
            messageType: "success",
          })
        );

        if (response.data.code >= 200 && response.data.code < 400) {
          setTimeout(() => {
            navigate("/manage-allowances");
          }, 1000);
        }

        reset({
          intBasicPayPercentage: "",
          intHouseRentAllowance: "",
          intVehicleAllowance: "",
          intOtherAllowance: "",
          intMedicalAllowance: "",
          txtCompanyName: "",
          intEsiPercentage: "",
          intEpfPercentage: "",
        });
        setCompanyName("");
      })
      .catch(function (error) {
        console.log(error);
        childRef.current.triggerAlert(
          JSON.stringify({
            message: "Something went wrong",
            messageType: "error",
          })
        );
      });
    //   .finally(function () {
    //     setBtnFlag(false);
    //   });
  }

  async function fetchData() {
    const data1 = JSON.stringify({
      intType: 4,
      intPayslipID: parseInt(id || 0),
    });
    config.method = "POST";
    config.data = data1;
    config.url = payslipDetailsAPI;
    axios(config)
      .then(function (response) {
        console.log(response.data.result);
        const responseTempData = response.data.result[0];
        handleFormReset(responseTempData);
      })
      .catch(function (error) {
        console.log(error);
        childRef.current.triggerAlert(
          JSON.stringify({
            message: "Something went wrong",
            messageType: "error",
          })
        );
      });
  }
  useEffect(() => {
    if (id !== undefined) {
      fetchData();
    }
  }, [id]);

  const handleFormReset = (data) => {
    if (isEditMode) {
      defaultValues.intBasicPayPercentage = data.basic_pay_percentage || "";
      defaultValues.intHouseRentAllowance = data.house_rent_allowance || "";
      defaultValues.intVehicleAllowance = data.vehicle_allowance || "";
      defaultValues.intOtherAllowance = data.other_allowance || "";
      defaultValues.intMedicalAllowance = data.medical_allowance || "";
      defaultValues.txtCompanyName = data.company_name || 0;
      defaultValues.intEsiPercentage = data.esi_percentage || "";
      defaultValues.intEpfPercentage = data.epf_percentage || "";
      setCompanyName(data.company_name || 0);
      reset({ ...defaultValues });
    }
  };

  return (
    <>
      <Layout>
        <AlertMessage ref={childRef} />
        <Grid className="employee-form">
          <Grid container spacing={3}>
            <Grid
              textAlign="center"
              item
              className="form-lable"
              xs={12}
              lg={6}
              md={6}
            >
              <Typography className="page_title" textAlign="left">
                Manage Allowances
              </Typography>
              <Breadcrumbs aria-label="breadcrumb">
                <Link underline="hover" color="inherit" href="/dashboard">
                  Dashboard
                </Link>
                <Link
                  underline="hover"
                  color="inherit"
                  href="/manage-allowances"
                >
                  Manage Allowances
                </Link>
                <Typography color="text.primary">
                  {isEditMode ? "Update" : "Add"}
                </Typography>
              </Breadcrumbs>
            </Grid>
            <Grid
              textAlign="right"
              item
              className="form-lable"
              xs={12}
              lg={6}
              md={6}
            >
              <LoadingButton
                size="medium"
                variant="contained"
                color="primary"
                onClick={() => navigate(-1)}
                startIcon={<ArrowBackIosIcon />}
              >
                Back
              </LoadingButton>
            </Grid>
          </Grid>
          <form onSubmit={handleSubmit(onSubmit)} className="form_design">
            <Grid container spacing={2}>
              <Grid item className="form-lable" xs={12} lg={12} md={12}>
                <Typography>
                  <p className="hint">
                    <span className="span_text">Note : </span>
                    Special Allowance Eligible after 1 year from joining and
                    every 6 months thereafter.
                  </p>
                  <p className="hint" style={{ marginTop: "5px" }}>
                    <span className="span_text">Note : </span>
                    ESI is available only for monthly salary below 21,000 and PF will be provided after 3 months of joining.
                  </p>
                </Typography>
              </Grid>
              <Grid
                item
                className="form-lable po_lebleterm"
                xs={12}
                lg={6}
                md={6}
              >
                <FormControl fullWidth variant="outlined">
                  {/* Autocomplete with Searchable Dropdown */}
                  <Autocomplete
                    options={Array.isArray(companyNames) ? companyNames : []} // Ensure it's an array
                    getOptionLabel={(option) => option?.company_name || ""}
                    value={
                      Array.isArray(companyNames)
                        ? companyNames.find(
                            (company) => company.id === companyName
                          ) || null
                        : null
                    }
                    onChange={(event, newValue) => {
                      const selectedId = newValue?.id
                        ? parseInt(newValue.id)
                        : 0;
                      setCompanyName(selectedId);
                      setValue("txtCompanyName", selectedId);
                    }}
                    readOnly={id ? true : false}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Company Name"
                        placeholder="Search Company"
                        variant="outlined"
                        focused
                      />
                    )}
                  />
                  {/* Validation Error Message */}
                  {errors?.txtCompanyName?.message && (
                    <Typography className="invalid-feedback">
                      {errors.txtCompanyName.message}
                    </Typography>
                  )}
                </FormControl>
              </Grid>
              <Grid item className="form-lable" xs={12} lg={6} md={6}>
                <TextField
                  name="basicpay"
                  type="text"
                  label="Basic Pay (%)"
                  fullWidth
                  focused
                  {...register("intBasicPayPercentage")}
                  error={errors.intBasicPayPercentage ? true : false}
                  helperText={errors.intBasicPayPercentage?.message}
                />
              </Grid>
              <Grid item className="form-lable" xs={12} lg={6} md={6}>
                <TextField
                  name="houserentallowance"
                  type="text"
                  label="House Rent Allowance(%)"
                  fullWidth
                  focused
                  {...register("intHouseRentAllowance")}
                  error={errors.intHouseRentAllowance ? true : false}
                  helperText={errors.intHouseRentAllowance?.message}
                />
              </Grid>
              <Grid item className="form-lable" xs={12} lg={6} md={6}>
                <TextField
                  name="MedicalAllowance"
                  type="text"
                  label="Conveyance Allowance(%)"
                  fullWidth
                  focused
                  {...register("intMedicalAllowance")}
                  error={errors.intMedicalAllowance ? true : false}
                  helperText={errors.intMedicalAllowance?.message}
                />
              </Grid>              
              <Grid item className="form-lable" xs={12} lg={6} md={6}>
                <TextField
                  name="vehicleallowance"
                  type="text"
                  label="Special Allowance(Rupees)"
                  fullWidth
                  focused
                  {...register("intVehicleAllowance")}
                  error={errors.intVehicleAllowance ? true : false}
                  helperText={errors.intVehicleAllowance?.message}
                />
              </Grid>
              <Grid item className="form-lable" xs={12} lg={6} md={6}>
                <TextField
                  name="other"
                  type="text"
                  label="Other Allowances(Rupees)"
                  fullWidth
                  focused
                  {...register("intOtherAllowance")}
                  error={errors.intOtherAllowance ? true : false}
                  helperText={errors.intOtherAllowance?.message}
                />
              </Grid>
              <Grid item className="form-lable" xs={12} lg={6} md={6}>
                <TextField
                  name="ESIPercentage"
                  type="text"
                  label="ESI Percentage(%)"
                  fullWidth
                  focused
                  {...register("intEsiPercentage")}
                  error={errors.intEsiPercentage ? true : false}
                  helperText={errors.intEsiPercentage?.message}
                />
              </Grid>
              <Grid item className="form-lable" xs={12} lg={6} md={6}>
                <TextField
                  name="EPFPercentage"
                  type="text"
                  label="EPF Percentage(%)"
                  fullWidth
                  focused
                  {...register("intEpfPercentage")}
                  error={errors.intEpfPercentage ? true : false}
                  helperText={errors.intEpfPercentage?.message}
                />
              </Grid>
              <div className="empty-space-20"></div>
              <FormControl
                sx={{ m: 0, width: "-webkit-fill-available" }}
                variant="standard"
              >
                <Grid container className="submit-button" alignItems="center">
                  <Grid item xs={12} lg={12} md={12}>
                    <LoadingButton
                      size="large"
                      variant="contained"
                      color="primary"
                      type="submit"
                      disabled={formState.isSubmitting}
                    >
                      {isEditMode ? "Update" : "Submit"}
                    </LoadingButton>
                  </Grid>
                </Grid>
              </FormControl>
            </Grid>
          </form>
        </Grid>
        <>
          <NavigationGuard />
        </>
      </Layout>
    </>
  );
}

export default ManageAllowancesAdd;
